import { ClientNextEngineLinkSimple } from "api/sms-api";
import {
  getClientNextEngineLinksStart,
  getClientNextEngineLinksSuccess,
  getClientNextEngineLinksError,
  deleteClientNextEngineLinkStart,
  deleteClientNextEngineLinkSuccess,
  deleteClientNextEngineLinkError,
  createClientNextEngineShippedOrdersStart,
  createClientNextEngineShippedOrdersSuccess,
  createClientNextEngineShippedOrdersError,
} from "./EcSettingsSlice";
import { AppDispatch } from "store/store";
import { httpWrapper } from "utils/http";
import { SMS_API_BASE } from "../../constants";
import { handleError } from "errors/errors";

export const getClientNextEngineLinks = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(getClientNextEngineLinksStart());
    const clientNextEngineLinks: Array<ClientNextEngineLinkSimple> = await httpWrapper<
      Array<ClientNextEngineLinkSimple>
    >("GET", `${SMS_API_BASE}/client_next_engine/all_with_session`, {});
    dispatch(getClientNextEngineLinksSuccess(clientNextEngineLinks));
  } catch (e) {
    handleError(e);
    dispatch(getClientNextEngineLinksError(e));
  }
};

export const deleteClientNextEngineLink = (
  clientNextEngineLinkId: string
) => async (dispatch: AppDispatch) => {
  try {
    dispatch(deleteClientNextEngineLinkStart());
    await httpWrapper<void>(
      "PUT",
      `${SMS_API_BASE}/client_next_engine/multiple_delete_with_session`,
      { clientNextEngineLinkIds: [clientNextEngineLinkId] }
    );
    dispatch(deleteClientNextEngineLinkSuccess());
    // Reload the next engine links
    dispatch(getClientNextEngineLinks());
  } catch (e) {
    handleError(e);
    dispatch(deleteClientNextEngineLinkError(e));
  }
};

export const createClientNextEngineShippedOrders = () => async (
  dispatch: AppDispatch
) => {
  try {
    dispatch(createClientNextEngineShippedOrdersStart());
    await httpWrapper<Array<ClientNextEngineLinkSimple>>(
      "GET",
      `${SMS_API_BASE}/client_next_engine/client_next_engine_shipped_orders`,
      {}
    );
    dispatch(createClientNextEngineShippedOrdersSuccess());
  } catch (e) {
    handleError(e);
    dispatch(createClientNextEngineShippedOrdersError(e));
  }
};
